<template>
  <personal-setting-form
    :personal-setting-data="personalSettingData"
    @updateEditData="updateEditData"
  />
</template>

<script>
import PersonalSettingForm from '../../SmartScheduling/components/PersonalSettingForm.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    PersonalSettingForm,
  },
  data: () => ({
    ...mapGetters('scheduling', [
      'getUserSettingData'
    ])
  }),
  computed: {
    personalSettingData() {
      return this.getUserSettingData()
    }
  },
  methods: {
    updateEditData(data) {
      this.$emit('updateUserSetting', data)
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
